import {ApiFunction, ChatbotApi} from "../chatbot/towersChatbotApi";

export const ogFunctions = {
    httpsCallable(functionName) {
        const fn = new ApiFunction("og-" + functionName, ChatbotApi.baseUrl);
        return fn.call.bind(fn);
    }
}
